import { AnswerDefinition, OrdChatFlowDefinition } from "@xflr6/chatbot";
import { clone } from "ramda";
import { v4 } from "uuid";

import { MCFlowEditorError } from "../../errors";
import { WithKey } from "./types";

/**
 * Inserts an answer into a prompt in the chat flow definition.
 * @param promptIndex
 * @param definition - If null, a stub definition is auto-generated and used
 * @param index - If null, the answer is added at the very end of the answers
 *   array in the prompt definition.
 * @param flowDef
 * @returns the definition of the answer created
 */
export function insertAnswer(
  promptIndex: number,
  definition: AnswerDefinition | null,
  index: number | null,
  flowDef: OrdChatFlowDefinition
): AnswerDefinition {
  const { definition: promptDef } = flowDef.promptsArray[promptIndex];
  const effectiveDef = definition != null ? clone(definition) : { message: "" };
  (effectiveDef as WithKey<AnswerDefinition>).__key = v4();
  if (promptDef.answers == null) {
    promptDef.answers = [];
  }
  const answers = promptDef.answers;
  if (!Array.isArray(answers)) {
    throw new MCFlowEditorError(
      `Prompt at index ${promptIndex} has non-array answers: ${answers}`
    );
  }
  if (index == null) {
    answers.push(effectiveDef);
  } else if (index > promptDef.answers.length) {
    throw new MCFlowEditorError(
      `Answer index ${index} out of bounds for prompt at index ${promptIndex}`
    );
  } else {
    answers.splice(index, 0, effectiveDef);
  }

  return effectiveDef;
}
